import { useTranslation } from 'react-i18next'
import CheckboxList from './CheckboxList'
import { isMigrateValue } from 'components/pages/dis/tile/utils/tileOtherOptionMigration'
import { enqueueSnackbar } from 'notistack'

export const DEFAULT_CHECKED_OPTIONS = [
	'enableActiveUpdate',
	'enableRefresh',
	'enableExport',
	'showResizeSlider',
	'isNewShowResizeSlider',
	'showInDashboard',
]

const OtherOptions = ({
	optionList,
	checkedOptions = DEFAULT_CHECKED_OPTIONS,
	migrateOtherOptions = [],
	onChangeOptions,
	hideScroll,
	tilte,
	marginTopTitle,
	onMigrateOtherOption,
	tileType,
}) => {
	const { t } = useTranslation('common')

	const handleOtherOptionsCheck = (value) => () => {
		if (!Array.isArray(checkedOptions)) return
		const currentIndex = checkedOptions?.indexOf(value)
		const newChecked = [...checkedOptions]

		if (currentIndex === -1) {
			if (value === 'showRepeatables' && !checkedOptions?.formKey) {
				enqueueSnackbar('Please select a form first', { variant: 'error' })
			} else {
				newChecked.push(value)
			}
		} else {
			newChecked.splice(currentIndex, 1)
		}

		if (tileType && onMigrateOtherOption) {
			const migrated = isMigrateValue(value, tileType)
			if (migrated && !migrateOtherOptions?.includes(value)) {
				onMigrateOtherOption([...migrateOtherOptions, value])
			}
		}
		onChangeOptions(newChecked)
	}

	return (
		<CheckboxList
			title={tilte || t('common:dis.otherOptions')}
			data={optionList}
			onItemClick={handleOtherOptionsCheck}
			checkedList={checkedOptions}
			getLabel={(option) => option.label}
			getValue={(option) => option.value}
			checkboxColor="warning"
			hideScroll={hideScroll}
			marginTopTitle={marginTopTitle}
		/>
	)
}

export default OtherOptions
